var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rich-preview"},[_c('div',{ref:"content",staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.html)},on:{"click":_vm.onElementClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }